module.exports = __webpack_public_path__ + "resources/images/tentamen-364ff8c8673fdef4d4448234a73385ed-cache.jpg";